export class SetIsAuthenticated {
  static readonly type = '[Auth] Set authenticated state';

  constructor(public isAuthenticated: boolean, public roles: string[] = []) {}
}
